import React from "react";
import style from "./Footer.module.css";
import { FooterNavList } from "../FooterNavList";
import { Link } from "react-router-dom";
import { SocialIconsList } from "../SocialIconsList";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import { FooterLogo, FooterMobileLogo } from "../../customIcons";

export const Footer = () => {
  const isDesktop = useMediaQuery("(min-width: 801px)");
  const currentYear = new Date().getFullYear();

  return (
    <footer className={style.footer}>
      <div className={"container"}>
        <div className={style.footerSocialInfo}>
          <Link to="/" aria-label="Home">
            {isDesktop ? <FooterLogo /> : <FooterMobileLogo />}
          </Link>
          <SocialIconsList fill={"#fff"} />
        </div>
        <div className={style.line} />
        <FooterNavList />
        <div className={style.footerInfo}>
          <ul>
            <li>
              <a href="tel:+17203806636">+1 720-380-6636</a>
            </li>
            <li>
              <a href="mailto:contact@homecraft-masters.com">
                contact@homecraft-masters.com
              </a>
            </li>
          </ul>
        </div>
        <div className={style.line} />
        <div className={style.footerCopyRight}>
          <p>© Homecraft-masters.com, all rights reserved {currentYear}</p>
          <div className={style.footerLinkAuthor}>
            <a
              target="_blank"
              href="https://ru.freepik.com/free-photo/mosaic-wood-pattern_4101422.htm#page=7&query=asymmetric%20form%20background&position=25&from_view=search&track=ais"
              rel="noreferrer"
            >
              Image from rawpixel.com on Freepik
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
